import React from 'react';
import {Row, Table } from 'antd'
import { useTranslation } from 'react-i18next';

const BenFinales = ({benFinales={}, actual, forceExpand}) => {
    const { t } = useTranslation();
    const sociedadesColumns = [
        {
            title: t("messages.aml.name"),
            dataIndex: 'name'
        },
        {
            title: t("messages.aml.identificationNumber"),
            dataIndex: 'nroDoc'
        },
        {
            title: t("messages.aml.nationality"),
            dataIndex: 'nacionalidad'
        },
        {
            title: t("messages.aml.residenceCountry"),
            dataIndex: 'pais'
        },
        {
            title: t("messages.aml.participationPercentage"),
            dataIndex: 'porcParti'
        },
    ]
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Table
                    className={actual && benFinales.records !== actual.records && "difference"}
                    columns={sociedadesColumns}
                    dataSource={benFinales.records}
                    pagination={!forceExpand && benFinales.records?.length > 10}
                />
            </Row>
        </div>
    );
};

export default BenFinales;